<template>
    <div class="ready-hand">
        <div class="ready-hand-outer">
            <div class="ready-hand-inner">
                <div class="ready-hand-image"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ready-hand',
    }
</script>

<style lang="less" scoped>
    @vibrationDistanceX: 5px;
    @vibrationDistanceY: 20%;
    @rotationDistance: 15deg;

    .ready-hand, .ready-hand-outer, .ready-hand-inner, .ready-hand-image {
        width: 205px;
        height: 194px;
    }

    .ready-hand {
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
    }

    .ready-hand-outer {
        animation: vibrate 5s ease-in-out infinite alternate-reverse both;
    }

    .ready-hand-inner {
        animation: vibrate-rotate 3s ease-in-out infinite alternate-reverse both;
    }

    .ready-hand-image {
        background: url("~@img/misc/ready-hand.png");
    }

    @keyframes vibrate {
        0% {
            transform: translate(0);
        }
        20% {
            transform: translate(-@vibrationDistanceX, @vibrationDistanceY) ro;
        }
        40% {
            transform: translate(-@vibrationDistanceX, -@vibrationDistanceY);
        }
        60% {
            transform: translate(@vibrationDistanceX, @vibrationDistanceY);
        }
        80% {
            transform: translate(@vibrationDistanceX, -@vibrationDistanceY);
        }
        100% {
            transform: translate(0);
        }
    }

    /**
     * ----------------------------------------
     * animation vibrate-1
     * ----------------------------------------
     */
    @keyframes vibrate-rotate {
        0% {
            transform: rotate(0deg);
        }
        20% {
            transform: rotate(-@rotationDistance);
        }
        40% {
            transform: rotate(@rotationDistance);
        }
        60% {
            transform: rotate(-@rotationDistance);
        }
        80% {
            transform: rotate(@rotationDistance);
        }
        100% {
            transform: rotate(0deg);
        }
    }
</style>